import { createPayPalPayment, type PaymentDetailsParamsPayPal } from '../../utils/serverAPI/createPayment';
import { selectAuthParams, selectSessionId, selectExperiments } from '../../selectors/index';
import { logXhrError } from '../../utils/sentry';
import { type StoreState } from '../../types/StoreState';
import { selectPayPalPaymentData } from '../../selectors/payment';
import { Experiment } from '../../types/Experiment';

/**
 * Sends request to Cashier backend to create PayPal payment details
 * @param params PaymentDetailsParamsPayPal
 * @param auth
 * @param auth.appInstance Signed instance that is used as Authorization header in REST API calls
 * @param [auth.revalidateAppInstance] Mechanism to revalidate the expired signed instance
 */
export const createPayPalPaymentDetails =
  (params: PaymentDetailsParamsPayPal) =>
  async (dispatch, getState: () => StoreState): Promise<string> => {
    const state = getState();
    const sessionId = selectSessionId(state);
    const experiments = selectExperiments(state);
    const { chargeId, cashierOrderId } = selectPayPalPaymentData(state);
    const reqArgs: Parameters<typeof createPayPalPayment>[0] = {
      sessionId,
      orderId: params.orderId,
      payerId: params.payerId,
    };

    if (chargeId && cashierOrderId) {
      reqArgs.chargeId = chargeId;
      reqArgs.cashierOrderId = cashierOrderId;
    }

    const confirmed = experiments[Experiment.PassConfirmedInExpressCheckout] === 'true' ? true : undefined;
    if (confirmed !== undefined) {
      reqArgs.confirmed = confirmed;
    }

    try {
      return await createPayPalPayment(reqArgs, selectAuthParams(state));
    } catch (e) {
      logXhrError({
        message: 'XHR: PayPal createPayPalPaymentDetails failed',
        axiosError: e,
        fingerprint: ['createPayPalPaymentDetails'],
        reqArgs,
      });
      throw e;
    }
  };
